module.exports = __webpack_public_path__ + "img/Shower.46c61fae.png";